import { $generateHtmlFromNodes } from "@lexical/html";
import type { EditorState, LexicalEditor } from "lexical";

export function renderEditorStateBrowser(editor: LexicalEditor, state: EditorState): string {
	editor.setEditorState(state);

	let html = '';
	editor.update(() => {
		html = $generateHtmlFromNodes(editor);
	})
	return html;
}
